import React from "react";
import TextField from "components/common/TextField/TextField";
import { isEmpty } from "lodash";
import { Col, Row } from "reactstrap";
import { IPaiyaCustomerChannelListProps } from "./CustomerChannelList.interface";
import "./CustomerChannelList.scss";
import { removeCharacterFromStringAndCapitalize } from "utils/lib";
import { ISelectedMovRefObject } from "interfaces/Index";
import { IPaiyaMovValuesError } from "../PaiyaMov.interface";

const CustomerChannelList = (props: IPaiyaCustomerChannelListProps) => {
  const [movValue, setMovValue] = React.useState<Number>(0);
  const [movValueError, setMovValueError] = React.useState<any>();

  const { selectedMov, setMovValidationState } = props;

  const handleMovValueChange = (
    e: any,
    item: ISelectedMovRefObject,
    index: number
  ) => {
    let obj = {};
    if (e.target.value <= 0) {
      obj = {
        ...movValueError,
        [`${item.title}_${index}`]: {
          error: true,
          id: `${item.title}_${index}`,
          msg: "Please enter valid MOV value",
          index,
        },
      };
      setMovValidationState(obj);
      setMovValueError(obj);
    } else {
      obj = {
        ...movValueError,
        [`${item.title}_${index}`]: {
          error: false,
          id: `${item.title}_${index}`,
          msg: "",
          index,
        },
      };
      setMovValidationState(obj);
      setMovValueError(obj);
    }
    selectedMov.current[index].value = e.target.value;
    setMovValue(e.target.value);
  };

  return (
    <section className="customer-channel-selected-list-container">
      <div className="customer-channel-selected-list-body">
        <section>
          <Row>
            <Col lg="7" className="customer-channel-list-heading">
              Customer Channel
            </Col>
            <Col lg="5" className="customer-channel-list-heading">
              MOV
            </Col>
          </Row>
          <Row>
            <>
              <br />
            </>
          </Row>
          <Row className="customer-channel-list">
            {!isEmpty(selectedMov.current) &&
              selectedMov.current.map(
                (item: ISelectedMovRefObject, index: number) => {
                  return (
                    <Col
                      key={item.id}
                      lg="12"
                      sm="12"
                      className="channel-list-row"
                    >
                      <Row>
                        <Col lg="7" className="customer-channel-list-item-text">
                          {removeCharacterFromStringAndCapitalize(
                            item.title || "",
                            "_"
                          )}
                        </Col>
                        <Col lg="5">
                          <TextField
                            value={item.value}
                            className="text-field-mov"
                            id={`${item.title}_${index}`}
                            label=""
                            error={
                              !isEmpty(movValueError) &&
                              !isEmpty(
                                movValueError[`${item.title}_${index}`]
                              ) &&
                              movValueError[`${item.title}_${index}`].error &&
                              movValueError[`${item.title}_${index}`].msg
                            }
                            handleChange={(e: any) =>
                              handleMovValueChange(e, item, index)
                            }
                            placeholder="0"
                            autoFocus={true}
                          />
                        </Col>
                      </Row>
                    </Col>
                  );
                }
              )}
          </Row>
        </section>
      </div>
    </section>
  );
};

export default CustomerChannelList;
